import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 12px;
    min-height: 90vh;
    width: 100%;
    box-sizing: border-box;
    background: linear-gradient(180deg, #eef2f7 0%, #f5f7fa 100%);
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    background-color: var(--surface);
    padding: 20px 16px;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(15, 40, 90, 0.08);
    width: 100%;
    max-width: 560px;
    box-sizing: border-box;

    @media (min-width: 480px) {
        padding: 28px;
        border-radius: 18px;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 20px;
`;

export const Eyebrow = styled.span`
    text-transform: uppercase;
    letter-spacing: 1.4px;
    font-size: 11px;
    font-weight: 700;
    color: #007bff;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: #1a2b45;
    line-height: 1.2;

    @media (min-width: 480px) {
        font-size: 24px;
    }
`;

export const Subtitle = styled.p`
    margin: 0;
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
`;

export const SectionLabel = styled.h4`
    margin: 12px 0 10px;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #94a3b8;
`;

export const DivDados = styled.div`
    display: flex;
    flex-direction: column;
`;

export const InputArea = styled.div`
    display: flex;
    flex-direction: column;
    background-color: var(--surface);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 92%;
    max-width: 400px;
`;

export const GradeGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-bottom: 4px;

    @media (max-width: 400px) {
        grid-template-columns: 1fr;
    }
`;

export const GradeField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const GradeLabel = styled.label`
    font-size: 13px;
    font-weight: 600;
    color: #475569;
`;

export const Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    padding: 11px 12px;
    border-radius: 10px;
    border: 1px solid #d7dfea;
    font-size: 15px;
    color: #1a2b45;
    transition: border-color 0.15s, box-shadow 0.15s;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
    }
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: 4px;
  margin-bottom: 25px;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

export const Hint = styled.div`
    padding: 16px;
    border-radius: 12px;
    background: #f8fafc;
    border: 1px dashed #cbd5e1;
    color: #64748b;
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
`;

export const CalendarWrap = styled.div`
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #e4e9f2;
    border-radius: 14px;
    padding: 12px;
    background: #fbfcfe;

    @media (min-width: 480px) {
        padding: 16px;
    }
`;

export const CalendarToolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
`;

export const MonthTitle = styled.span`
    font-size: 15px;
    font-weight: 700;
    color: #1a2b45;
    text-align: center;
    flex: 1;
`;

export const ToolbarButton = styled.button`
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    border: 1px solid #dbe3ef;
    background: var(--surface);
    color: #334155;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, opacity 0.15s;

    &:hover:not(:disabled) {
        background: #eef4ff;
        border-color: #7ea6e8;
    }

    &:disabled {
        opacity: 0.35;
        cursor: not-allowed;
    }
`;

export const CalendarGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;

    @media (min-width: 480px) {
        gap: 6px;
    }
`;

export const WeekdayCell = styled.div`
    text-align: center;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    color: #94a3b8;
    padding-bottom: 4px;

    @media (min-width: 480px) {
        font-size: 11px;
    }
`;

export const EmptyCell = styled.div`
    aspect-ratio: 1 / 1;
`;

export const DayCell = styled.button`
    aspect-ratio: 1 / 1;
    width: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    cursor: pointer;
    transition: transform 0.08s, background 0.15s, border-color 0.15s, box-shadow 0.15s;

    border: 1px solid
        ${({ $disabled, $active, $weekend }) =>
            $active ? '#0d9f6e' : $disabled ? 'transparent' : $weekend ? '#eef0f4' : '#e1e7f0'};

    background: ${({ $disabled, $active, $weekend }) =>
        $active ? '#12b981' : $disabled ? 'transparent' : $weekend ? '#f4f6fa' : '#ffffff'};

    color: ${({ $disabled, $active, $weekend }) =>
        $active ? 'var(--surface)' : $disabled ? '#cbd2de' : $weekend ? '#9aa5b8' : '#334155'};

    font-weight: ${({ $active }) => ($active ? 700 : 500)};

    ${({ $disabled, $active }) =>
        $disabled &&
        !$active &&
        `
        cursor: not-allowed;
        opacity: 0.45;
    `}

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 4px 10px rgba(18, 185, 129, ${({ $active }) => ($active ? 0.28 : 0.12)});
        border-color: ${({ $active }) => ($active ? '#0d9f6e' : '#12b981')};
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }
`;

export const DayNumber = styled.span`
    font-size: 14px;
`;

export const LegendRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid #eef1f6;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #64748b;
`;

export const LegendSwatch = styled.span`
    width: 14px;
    height: 14px;
    border-radius: 5px;
    flex-shrink: 0;
    background: ${({ $variant }) =>
        $variant === 'active'
            ? '#12b981'
            : $variant === 'disabled'
            ? '#f1f3f7'
            : '#ffffff'};
    border: 1px solid
        ${({ $variant }) =>
            $variant === 'active'
                ? '#0d9f6e'
                : $variant === 'disabled'
                ? '#e2e6ee'
                : '#dbe3ef'};
    ${({ $variant }) => $variant === 'disabled' && 'opacity: 0.6;'}
`;

export const StatsBar = styled.div`
    display: flex;
    margin: 18px 0 4px;
`;

export const StatBlock = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 14px;
    background: #f1f6ff;
    border: 1px solid #dbe7fb;
    border-radius: 12px;
`;

export const StatValue = styled.span`
    font-size: 26px;
    font-weight: 800;
    color: #007bff;
    line-height: 1;
`;

export const StatLabel = styled.span`
    font-size: 12px;
    color: #7c8db5;
    font-weight: 600;
`;

export const Btt02 = styled.button`
    width: 100%;
    padding: 13px;
    border: none;
    border-radius: 11px;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    margin-top: 22px;
    margin-bottom: 16px;
    transition: background-color 0.15s, transform 0.08s;

    &:hover {
        background-color: #0056b3;
    }

    &:active {
        transform: translateY(1px);
    }
`;

export const ToGoBack = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

export const SignMessageButtonText = styled.span`
    color: var(--text, var(--text-muted));
`;

export const SignMessageButtonTextBold = styled.span`
    color: #007bff;
    font-weight: bold;
    margin-left: 5px;
`;

export const ErrorMessage = styled.div`
  color: #dc2626;
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;